import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import * as actions from '../actions/'
import { updateClientMetricMuted } from '../actions/'
import Settings, { Props } from '../components/Settings'
import { createGuid } from '../guids'
import { appPermissions } from '../roles-permissions'
import { LimitType, Model } from '../types/types'
import {alertLevelDecoder} from "../web/decoders";
import {ClientCode} from "../types/clients";

type ContainerStateProps = Pick<
  Props,
  'user' | 'mutedClientMetrics' | 'hasPermission'
>

type ContainerDispatchProps = Pick<
  Props,
  | 'onLogoutClicked'
  | 'toggleMute'
  | 'updateTCSLimitsClicked'
>

export function mapDispatchToProps(
  dispatch: Dispatch<actions.RootAction>,
): ContainerDispatchProps {
  return {
    onLogoutClicked: (): void => {
      dispatch(actions.logout())
    },
    toggleMute: (
      clientCode: ClientCode,
      metric: LimitType,
    ): ReturnType<Props['toggleMute']> => (): void => {
      dispatch(updateClientMetricMuted(clientCode, metric, 'toggle'))
    },
    updateTCSLimitsClicked: (): void => {
      dispatch(
        actions.displayToasts([
          {
            content:
              "It may take several minutes to perform the operation. We'll tell you when we're done",
            header: 'TCS Limit Update',
            id: createGuid(),
          },
        ]),
      )
      dispatch(actions.updateAllClientTCSLimits())
    },
  }
}

export function mapStateToProps({
  alertLevel,
  mutedClientMetrics,
  user,
}: Model): ContainerStateProps {
  return {
    hasPermission: appPermissions,
    mutedClientMetrics,
    user,
  }
}

function mergeProps(
  stateProps: ContainerStateProps,
  dispatchProps: ContainerDispatchProps,
  ownProps: {}, // Is this the correct type???
): ContainerStateProps & ContainerDispatchProps {
  return { ...ownProps, ...stateProps, ...dispatchProps }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(Settings)
